function nr(r) {
  var e, t, n = "";
  if (typeof r == "string" || typeof r == "number") n += r;
  else if (typeof r == "object") if (Array.isArray(r)) for (e = 0; e < r.length; e++) r[e] && (t = nr(r[e])) && (n && (n += " "), n += t);
  else for (e in r) r[e] && (n && (n += " "), n += e);
  return n;
}
function U() {
  for (var r, e, t = 0, n = ""; t < arguments.length; ) (r = arguments[t++]) && (e = nr(r)) && (n && (n += " "), n += e);
  return n;
}
const D = (r) => typeof r == "boolean" ? "".concat(r) : r === 0 ? "0" : r, ar = (r) => {
  const e = function() {
    for (var s = arguments.length, o = new Array(s), a = 0; a < s; a++)
      o[a] = arguments[a];
    var c, i;
    return typeof (r == null || (c = r.hooks) === null || c === void 0 ? void 0 : c["cx:done"]) < "u" ? r == null ? void 0 : r.hooks["cx:done"](U(o)) : typeof (r == null || (i = r.hooks) === null || i === void 0 ? void 0 : i.onComplete) < "u" ? r == null ? void 0 : r.hooks.onComplete(U(o)) : U(o);
  };
  return { compose: function() {
    for (var s = arguments.length, o = new Array(s), a = 0; a < s; a++)
      o[a] = arguments[a];
    return (c) => {
      const i = Object.fromEntries(Object.entries(c || {}).filter((g) => {
        let [y] = g;
        return !["class", "className"].includes(y);
      }));
      return e(o.map((g) => g(i)), c == null ? void 0 : c.class, c == null ? void 0 : c.className);
    };
  }, cva: (s) => (o) => {
    var a;
    if ((s == null ? void 0 : s.variants) == null) return e(s == null ? void 0 : s.base, o == null ? void 0 : o.class, o == null ? void 0 : o.className);
    const { variants: c, defaultVariants: i } = s, g = Object.keys(c).map((b) => {
      const m = o == null ? void 0 : o[b], x = i == null ? void 0 : i[b], h = D(m) || D(x);
      return c[b][h];
    }), y = { ...i, ...o && Object.entries(o).reduce((b, m) => {
      let [x, h] = m;
      return typeof h > "u" ? b : { ...b, [x]: h };
    }, {}) }, p = s == null || (a = s.compoundVariants) === null || a === void 0 ? void 0 : a.reduce((b, m) => {
      let { class: x, className: h, ...f } = m;
      return Object.entries(f).every((v) => {
        let [w, S] = v;
        const M = y[w];
        return Array.isArray(S) ? S.includes(M) : M === S;
      }) ? [...b, x, h] : b;
    }, []);
    return e(s == null ? void 0 : s.base, g, p, o == null ? void 0 : o.class, o == null ? void 0 : o.className);
  }, cx: e };
}, { compose: Jr, cva: Xr, cx: Zr } = ar(), K = "-";
function ur(r) {
  const e = yr(r), {
    conflictingClassGroups: t,
    conflictingClassGroupModifiers: n
  } = r;
  function s(a) {
    const c = a.split(K);
    return c[0] === "" && c.length !== 1 && c.shift(), cr(c, e) || gr(a);
  }
  function o(a, c) {
    const i = t[a] || [];
    return c && n[a] ? [...i, ...n[a]] : i;
  }
  return {
    getClassGroupId: s,
    getConflictingClassGroupIds: o
  };
}
function cr(r, e) {
  var a;
  if (r.length === 0)
    return e.classGroupId;
  const t = r[0], n = e.nextPart.get(t), s = n ? cr(r.slice(1), n) : void 0;
  if (s)
    return s;
  if (e.validators.length === 0)
    return;
  const o = r.join(K);
  return (a = e.validators.find(({
    validator: c
  }) => c(o))) == null ? void 0 : a.classGroupId;
}
const rr = /^\[(.+)\]$/;
function gr(r) {
  if (rr.test(r)) {
    const e = rr.exec(r)[1], t = e == null ? void 0 : e.substring(0, e.indexOf(":"));
    if (t)
      return "arbitrary.." + t;
  }
}
function yr(r) {
  const {
    theme: e,
    prefix: t
  } = r, n = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return fr(Object.entries(r.classGroups), t).forEach(([o, a]) => {
    F(a, n, o, e);
  }), n;
}
function F(r, e, t, n) {
  r.forEach((s) => {
    if (typeof s == "string") {
      const o = s === "" ? e : er(e, s);
      o.classGroupId = t;
      return;
    }
    if (typeof s == "function") {
      if (br(s)) {
        F(s(n), e, t, n);
        return;
      }
      e.validators.push({
        validator: s,
        classGroupId: t
      });
      return;
    }
    Object.entries(s).forEach(([o, a]) => {
      F(a, er(e, o), t, n);
    });
  });
}
function er(r, e) {
  let t = r;
  return e.split(K).forEach((n) => {
    t.nextPart.has(n) || t.nextPart.set(n, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), t = t.nextPart.get(n);
  }), t;
}
function br(r) {
  return r.isThemeGetter;
}
function fr(r, e) {
  return e ? r.map(([t, n]) => {
    const s = n.map((o) => typeof o == "string" ? e + o : typeof o == "object" ? Object.fromEntries(Object.entries(o).map(([a, c]) => [e + a, c])) : o);
    return [t, s];
  }) : r;
}
function pr(r) {
  if (r < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let e = 0, t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map();
  function s(o, a) {
    t.set(o, a), e++, e > r && (e = 0, n = t, t = /* @__PURE__ */ new Map());
  }
  return {
    get(o) {
      let a = t.get(o);
      if (a !== void 0)
        return a;
      if ((a = n.get(o)) !== void 0)
        return s(o, a), a;
    },
    set(o, a) {
      t.has(o) ? t.set(o, a) : s(o, a);
    }
  };
}
const sr = "!";
function hr(r) {
  const {
    separator: e,
    experimentalParseClassName: t
  } = r, n = e.length === 1, s = e[0], o = e.length;
  function a(c) {
    const i = [];
    let g = 0, y = 0, p;
    for (let f = 0; f < c.length; f++) {
      let v = c[f];
      if (g === 0) {
        if (v === s && (n || c.slice(f, f + o) === e)) {
          i.push(c.slice(y, f)), y = f + o;
          continue;
        }
        if (v === "/") {
          p = f;
          continue;
        }
      }
      v === "[" ? g++ : v === "]" && g--;
    }
    const b = i.length === 0 ? c : c.substring(y), m = b.startsWith(sr), x = m ? b.substring(1) : b, h = p && p > y ? p - y : void 0;
    return {
      modifiers: i,
      hasImportantModifier: m,
      baseClassName: x,
      maybePostfixModifierPosition: h
    };
  }
  return t ? function(i) {
    return t({
      className: i,
      parseClassName: a
    });
  } : a;
}
function mr(r) {
  if (r.length <= 1)
    return r;
  const e = [];
  let t = [];
  return r.forEach((n) => {
    n[0] === "[" ? (e.push(...t.sort(), n), t = []) : t.push(n);
  }), e.push(...t.sort()), e;
}
function vr(r) {
  return {
    cache: pr(r.cacheSize),
    parseClassName: hr(r),
    ...ur(r)
  };
}
const xr = /\s+/;
function wr(r, e) {
  const {
    parseClassName: t,
    getClassGroupId: n,
    getConflictingClassGroupIds: s
  } = e, o = /* @__PURE__ */ new Set();
  return r.trim().split(xr).map((a) => {
    const {
      modifiers: c,
      hasImportantModifier: i,
      baseClassName: g,
      maybePostfixModifierPosition: y
    } = t(a);
    let p = !!y, b = n(p ? g.substring(0, y) : g);
    if (!b) {
      if (!p)
        return {
          isTailwindClass: !1,
          originalClassName: a
        };
      if (b = n(g), !b)
        return {
          isTailwindClass: !1,
          originalClassName: a
        };
      p = !1;
    }
    const m = mr(c).join(":");
    return {
      isTailwindClass: !0,
      modifierId: i ? m + sr : m,
      classGroupId: b,
      originalClassName: a,
      hasPostfixModifier: p
    };
  }).reverse().filter((a) => {
    if (!a.isTailwindClass)
      return !0;
    const {
      modifierId: c,
      classGroupId: i,
      hasPostfixModifier: g
    } = a, y = c + i;
    return o.has(y) ? !1 : (o.add(y), s(i, g).forEach((p) => o.add(c + p)), !0);
  }).reverse().map((a) => a.originalClassName).join(" ");
}
function kr() {
  let r = 0, e, t, n = "";
  for (; r < arguments.length; )
    (e = arguments[r++]) && (t = lr(e)) && (n && (n += " "), n += t);
  return n;
}
function lr(r) {
  if (typeof r == "string")
    return r;
  let e, t = "";
  for (let n = 0; n < r.length; n++)
    r[n] && (e = lr(r[n])) && (t && (t += " "), t += e);
  return t;
}
function or(r, ...e) {
  let t, n, s, o = a;
  function a(i) {
    const g = e.reduce((y, p) => p(y), r());
    return t = vr(g), n = t.cache.get, s = t.cache.set, o = c, c(i);
  }
  function c(i) {
    const g = n(i);
    if (g)
      return g;
    const y = wr(i, t);
    return s(i, y), y;
  }
  return function() {
    return o(kr.apply(null, arguments));
  };
}
function d(r) {
  const e = (t) => t[r] || [];
  return e.isThemeGetter = !0, e;
}
const ir = /^\[(?:([a-z-]+):)?(.+)\]$/i, Cr = /^\d+\/\d+$/, zr = /* @__PURE__ */ new Set(["px", "full", "screen"]), Ar = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, Sr = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, Mr = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, Pr = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, Gr = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/;
function k(r) {
  return A(r) || zr.has(r) || Cr.test(r);
}
function C(r) {
  return P(r, "length", Lr);
}
function A(r) {
  return !!r && !Number.isNaN(Number(r));
}
function L(r) {
  return P(r, "number", A);
}
function I(r) {
  return !!r && Number.isInteger(Number(r));
}
function Rr(r) {
  return r.endsWith("%") && A(r.slice(0, -1));
}
function l(r) {
  return ir.test(r);
}
function z(r) {
  return Ar.test(r);
}
const Ir = /* @__PURE__ */ new Set(["length", "size", "percentage"]);
function Nr(r) {
  return P(r, Ir, dr);
}
function Tr(r) {
  return P(r, "position", dr);
}
const jr = /* @__PURE__ */ new Set(["image", "url"]);
function Er(r) {
  return P(r, jr, $r);
}
function Vr(r) {
  return P(r, "", Wr);
}
function N() {
  return !0;
}
function P(r, e, t) {
  const n = ir.exec(r);
  return n ? n[1] ? typeof e == "string" ? n[1] === e : e.has(n[1]) : t(n[2]) : !1;
}
function Lr(r) {
  return Sr.test(r) && !Mr.test(r);
}
function dr() {
  return !1;
}
function Wr(r) {
  return Pr.test(r);
}
function $r(r) {
  return Gr.test(r);
}
function tr() {
  const r = d("colors"), e = d("spacing"), t = d("blur"), n = d("brightness"), s = d("borderColor"), o = d("borderRadius"), a = d("borderSpacing"), c = d("borderWidth"), i = d("contrast"), g = d("grayscale"), y = d("hueRotate"), p = d("invert"), b = d("gap"), m = d("gradientColorStops"), x = d("gradientColorStopPositions"), h = d("inset"), f = d("margin"), v = d("opacity"), w = d("padding"), S = d("saturate"), M = d("scale"), q = d("sepia"), _ = d("skew"), J = d("space"), X = d("translate"), W = () => ["auto", "contain", "none"], $ = () => ["auto", "hidden", "clip", "visible", "scroll"], O = () => ["auto", l, e], u = () => [l, e], Z = () => ["", k, C], j = () => ["auto", A, l], H = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], E = () => ["solid", "dashed", "dotted", "double", "none"], Q = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], B = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], G = () => ["", "0", l], Y = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], R = () => [A, L], V = () => [A, l];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [N],
      spacing: [k, C],
      blur: ["none", "", z, l],
      brightness: R(),
      borderColor: [r],
      borderRadius: ["none", "", "full", z, l],
      borderSpacing: u(),
      borderWidth: Z(),
      contrast: R(),
      grayscale: G(),
      hueRotate: V(),
      invert: G(),
      gap: u(),
      gradientColorStops: [r],
      gradientColorStopPositions: [Rr, C],
      inset: O(),
      margin: O(),
      opacity: R(),
      padding: u(),
      saturate: R(),
      scale: R(),
      sepia: G(),
      skew: V(),
      space: u(),
      translate: u()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", l]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [z]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": Y()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": Y()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...H(), l]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: $()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": $()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": $()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: W()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": W()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": W()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [h]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [h]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [h]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [h]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [h]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [h]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [h]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [h]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [h]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", I, l]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: O()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", l]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: G()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: G()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", I, l]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [N]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", I, l]
        }, l]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": j()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": j()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [N]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [I, l]
        }, l]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": j()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": j()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", l]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", l]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [b]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [b]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [b]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...B()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...B(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...B(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [w]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [w]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [w]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [w]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [w]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [w]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [w]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [w]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [w]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [f]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [f]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [f]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [f]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [f]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [f]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [f]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [f]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [f]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [J]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [J]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", l, e]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [l, e, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [l, e, "none", "full", "min", "max", "fit", "prose", {
          screen: [z]
        }, z]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [l, e, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [l, e, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [l, e, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [l, e, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", z, C]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", L]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [N]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", l]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", A, L]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", k, l]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", l]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", l]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [r]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [v]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [r]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [v]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...E(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", k, C]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", k, l]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [r]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: u()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", l]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", l]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [v]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...H(), Tr]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", Nr]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, Er]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [r]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [x]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [x]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [x]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [m]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [m]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [m]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [o]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [o]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [o]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [o]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [o]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [o]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [o]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [o]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [o]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [o]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [o]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [o]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [o]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [o]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [o]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [c]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [c]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [c]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [c]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [c]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [c]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [c]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [c]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [c]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [v]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...E(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [c]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [c]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [v]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: E()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [s]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [s]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [s]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [s]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [s]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [s]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [s]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [s]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...E()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [k, l]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [k, C]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [r]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: Z()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [r]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [v]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [k, C]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [r]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", z, Vr]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [N]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [v]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...Q(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": Q()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [t]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [n]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [i]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", z, l]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [g]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [y]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [p]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [S]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [q]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [t]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [n]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [i]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [g]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [y]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [p]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [v]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [S]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [q]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [a]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [a]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [a]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", l]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: V()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", l]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: V()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", l]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [M]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [M]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [M]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [I, l]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [X]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [X]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [_]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [_]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", l]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", r]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", l]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [r]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": u()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": u()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": u()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": u()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": u()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": u()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": u()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": u()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": u()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": u()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": u()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": u()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": u()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": u()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": u()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": u()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": u()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": u()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", l]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [r, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [k, C, L]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [r, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}
function Or(r, {
  cacheSize: e,
  prefix: t,
  separator: n,
  experimentalParseClassName: s,
  extend: o = {},
  override: a = {}
}) {
  T(r, "cacheSize", e), T(r, "prefix", t), T(r, "separator", n), T(r, "experimentalParseClassName", s);
  for (const c in a)
    Br(r[c], a[c]);
  for (const c in o)
    Ur(r[c], o[c]);
  return r;
}
function T(r, e, t) {
  t !== void 0 && (r[e] = t);
}
function Br(r, e) {
  if (e)
    for (const t in e)
      T(r, t, e[t]);
}
function Ur(r, e) {
  if (e)
    for (const t in e) {
      const n = e[t];
      n !== void 0 && (r[t] = (r[t] || []).concat(n));
    }
}
function Fr(r, ...e) {
  return typeof r == "function" ? or(tr, r, ...e) : or(() => Or(tr(), r), ...e);
}
var Kr = {
  prefix: "cur-",
  extend: {
    classGroups: {
      "font-family": ["text-body", "text-display", "text-heading", "text-mono"],
      "font-size": ["text-d1", "text-d1m", "text-d2", "text-d2m", "text-h1", "text-h2", "text-h3", "text-subhead", "text-body", "text-body-lg", "text-meta", "text-cta"],
      "font-weight": ["text-thin", "text-light", "text-normal", "text-medium", "text-bold", "text-extrabold", "text-black"],
      leading: ["leading-d1", "leading-d1m", "leading-d2", "leading-d2m", "leading-h1", "leading-h2", "leading-h3", "leading-subhead", "leading-body", "leading-body-lg", "leading-meta", "leading-cta"],
      tracking: ["tracking-d1", "tracking-d1m", "tracking-d2", "tracking-d2m", "tracking-h1", "tracking-h2", "tracking-h3", "tracking-subhead", "tracking-body", "tracking-body-lg", "tracking-meta", "tracking-cta"]
    },
    theme: {
      borderWidth: ["0", "2", "3", "4", ""],
      spacing: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "10", "12", "17", "20", "25", "100", "px"],
      colors: [
        "transparent",
        "current",
        "inherit",
        "curology-primary-50",
        "curology-primary-100",
        "curology-primary-200",
        "curology-primary-300",
        "curology-primary-400",
        "curology-primary-500",
        "curology-primary-600",
        "curology-primary-700",
        "curology-primary-800",
        "curology-primary-900",
        "curology-primary",
        "curology-secondary-50",
        "curology-secondary-100",
        "curology-secondary-200",
        "curology-secondary-250",
        "curology-secondary-300",
        "curology-secondary-400",
        "curology-secondary-500",
        "curology-secondary-600",
        "curology-secondary-700",
        "curology-secondary-800",
        "curology-secondary-900",
        "curology-secondary",
        "curology-brand-50",
        "curology-brand-100",
        "curology-brand-200",
        "curology-brand-300",
        "curology-brand-400",
        "curology-brand-500",
        "curology-brand-600",
        "curology-brand-700",
        "curology-brand-800",
        "curology-brand-900",
        "curology-brand",
        "curology-brand-light-50",
        "curology-brand-light-100",
        "curology-brand-light-200",
        "curology-brand-light-300",
        "curology-brand-light-400",
        "curology-brand-light-500",
        "curology-brand-light-600",
        "curology-brand-light-700",
        "curology-brand-light-800",
        "curology-brand-light-900",
        "curology-brand-light",
        "curology-brand-lightest-50",
        "curology-brand-lightest-100",
        "curology-brand-lightest-200",
        "curology-brand-lightest-300",
        "curology-brand-lightest-400",
        "curology-brand-lightest-500",
        "curology-brand-lightest-600",
        "curology-brand-lightest-700",
        "curology-brand-lightest-800",
        "curology-brand-lightest-900",
        "curology-brand-lightest",
        "curology-brand-accent-50",
        "curology-brand-accent-100",
        "curology-brand-accent-200",
        "curology-brand-accent-300",
        "curology-brand-accent-400",
        "curology-brand-accent-500",
        "curology-brand-accent-600",
        "curology-brand-accent-700",
        "curology-brand-accent-800",
        "curology-brand-accent-900",
        "curology-brand-accent",
        "curology-error-50",
        "curology-error-100",
        "curology-error-200",
        "curology-error-300",
        "curology-error-500",
        "curology-error-600",
        "curology-error-700",
        "curology-error-800",
        "curology-error-900",
        "curology-error",
        "curology-success-50",
        "curology-success-100",
        "curology-success-200",
        "curology-success-300",
        "curology-success-400",
        "curology-success-500",
        "curology-success-600",
        "curology-success-700",
        "curology-success-800",
        "curology-success-900",
        "curology-success",
        "curology-neutral-0",
        "curology-neutral-100",
        "curology-neutral-200",
        "curology-neutral-300",
        "curology-neutral-400",
        "curology-neutral-500",
        "curology-neutral-600",
        "curology-neutral-700",
        "curology-neutral-800",
        "curology-neutral-900",
        "curology-neutral",
        "agency-primary-200",
        "agency-primary-300",
        "agency-primary-400",
        "agency-primary",
        "agency-secondary-50",
        "agency-secondary-100",
        "agency-secondary-200",
        "agency-secondary-300",
        "agency-secondary-400",
        "agency-secondary-500",
        "agency-secondary-600",
        "agency-secondary-700",
        "agency-secondary-800",
        "agency-secondary-900",
        "agency-secondary-1000",
        "agency-secondary",
        "agency-brand-50",
        "agency-brand-75",
        "agency-brand-100",
        "agency-brand-150",
        "agency-brand-200",
        "agency-brand-300",
        "agency-brand-400",
        "agency-brand-500",
        "agency-brand-600",
        "agency-brand-700",
        "agency-brand-800",
        "agency-brand-900",
        "agency-brand",
        "agency-error-50",
        "agency-error-100",
        "agency-error-200",
        "agency-error-300",
        "agency-error-400",
        "agency-error-500",
        "agency-error-600",
        "agency-error-700",
        "agency-error-800",
        "agency-error-900",
        "agency-error-1000",
        "agency-error",
        "agency-success-50",
        "agency-success-100",
        "agency-success-200",
        "agency-success-300",
        "agency-success-400",
        "agency-success-500",
        "agency-success-600",
        "agency-success-700",
        "agency-success-800",
        "agency-success-900",
        "agency-success-1000",
        "agency-success",
        "agency-neutral-0",
        "agency-neutral-50",
        "agency-neutral-100",
        "agency-neutral-200",
        "agency-neutral-300",
        "agency-neutral-400",
        "agency-neutral-500",
        "agency-neutral-600",
        "agency-neutral-700",
        "agency-neutral-800",
        "agency-neutral-900",
        "agency-neutral",
        "primary",
        "subtle",
        "brand",
        "inverse",
        "error",
        "success",
        "warning",
        "highlight",
        "disabled",
        "black",
        "white",
        "surface-primary",
        "surface-primary-hover",
        "surface-primary-selected",
        "surface-secondary",
        "surface-secondary-hover",
        "surface-secondary-selected",
        "surface-brand",
        "surface-brand-hover",
        "surface-brand-selected",
        "surface-brand-light",
        "surface-brand-light-hover",
        "surface-brand-light-selected",
        "surface-brand-lightest",
        "surface-brand-lightest-hover",
        "surface-brand-lightest-selected",
        "surface-neutral",
        "surface-neutral-hover",
        "surface-neutral-selected",
        "surface-error",
        "surface-error-hover",
        "surface-error-selected",
        "surface-success",
        "surface-success-hover",
        "surface-success-selected",
        "surface-warning",
        "surface-warning-hover",
        "surface-warning-selected",
        "surface-highlight",
        "surface-highlight-hover",
        "surface-highlight-selected",
        "surface-error-bold",
        "surface-error-bold-hover",
        "surface-error-bold-selected",
        "surface-success-bold",
        "surface-success-bold-hover",
        "surface-success-bold-selected",
        "surface-brand-accent",
        "surface-disabled",
        "border-secondary",
        "border-secondary-hover",
        "border-secondary-selected",
        "border-subtle",
        "border-subtle-hover",
        "border-subtle-selected",
        "border-brand",
        "border-brand-hover",
        "border-brand-selected",
        "border-error",
        "border-error-hover",
        "border-error-selected",
        "border-success",
        "border-success-hover",
        "border-success-selected",
        "border-warning",
        "border-warning-hover",
        "border-warning-selected",
        "border-highlight",
        "border-highlight-hover",
        "border-highlight-selected",
        "border-brand-light",
        "border-inverse",
        "border-disabled",
        "focus"
      ],
      borderColor: [
        "transparent",
        "current",
        "inherit",
        "curology-primary-50",
        "curology-primary-100",
        "curology-primary-200",
        "curology-primary-300",
        "curology-primary-400",
        "curology-primary-500",
        "curology-primary-600",
        "curology-primary-700",
        "curology-primary-800",
        "curology-primary-900",
        "curology-primary",
        "curology-secondary-50",
        "curology-secondary-100",
        "curology-secondary-200",
        "curology-secondary-250",
        "curology-secondary-300",
        "curology-secondary-400",
        "curology-secondary-500",
        "curology-secondary-600",
        "curology-secondary-700",
        "curology-secondary-800",
        "curology-secondary-900",
        "curology-secondary",
        "curology-brand-50",
        "curology-brand-100",
        "curology-brand-200",
        "curology-brand-300",
        "curology-brand-400",
        "curology-brand-500",
        "curology-brand-600",
        "curology-brand-700",
        "curology-brand-800",
        "curology-brand-900",
        "curology-brand",
        "curology-brand-light-50",
        "curology-brand-light-100",
        "curology-brand-light-200",
        "curology-brand-light-300",
        "curology-brand-light-400",
        "curology-brand-light-500",
        "curology-brand-light-600",
        "curology-brand-light-700",
        "curology-brand-light-800",
        "curology-brand-light-900",
        "curology-brand-light",
        "curology-brand-lightest-50",
        "curology-brand-lightest-100",
        "curology-brand-lightest-200",
        "curology-brand-lightest-300",
        "curology-brand-lightest-400",
        "curology-brand-lightest-500",
        "curology-brand-lightest-600",
        "curology-brand-lightest-700",
        "curology-brand-lightest-800",
        "curology-brand-lightest-900",
        "curology-brand-lightest",
        "curology-brand-accent-50",
        "curology-brand-accent-100",
        "curology-brand-accent-200",
        "curology-brand-accent-300",
        "curology-brand-accent-400",
        "curology-brand-accent-500",
        "curology-brand-accent-600",
        "curology-brand-accent-700",
        "curology-brand-accent-800",
        "curology-brand-accent-900",
        "curology-brand-accent",
        "curology-error-50",
        "curology-error-100",
        "curology-error-200",
        "curology-error-300",
        "curology-error-500",
        "curology-error-600",
        "curology-error-700",
        "curology-error-800",
        "curology-error-900",
        "curology-error",
        "curology-success-50",
        "curology-success-100",
        "curology-success-200",
        "curology-success-300",
        "curology-success-400",
        "curology-success-500",
        "curology-success-600",
        "curology-success-700",
        "curology-success-800",
        "curology-success-900",
        "curology-success",
        "curology-neutral-0",
        "curology-neutral-100",
        "curology-neutral-200",
        "curology-neutral-300",
        "curology-neutral-400",
        "curology-neutral-500",
        "curology-neutral-600",
        "curology-neutral-700",
        "curology-neutral-800",
        "curology-neutral-900",
        "curology-neutral",
        "agency-primary-200",
        "agency-primary-300",
        "agency-primary-400",
        "agency-primary",
        "agency-secondary-50",
        "agency-secondary-100",
        "agency-secondary-200",
        "agency-secondary-300",
        "agency-secondary-400",
        "agency-secondary-500",
        "agency-secondary-600",
        "agency-secondary-700",
        "agency-secondary-800",
        "agency-secondary-900",
        "agency-secondary-1000",
        "agency-secondary",
        "agency-brand-50",
        "agency-brand-75",
        "agency-brand-100",
        "agency-brand-150",
        "agency-brand-200",
        "agency-brand-300",
        "agency-brand-400",
        "agency-brand-500",
        "agency-brand-600",
        "agency-brand-700",
        "agency-brand-800",
        "agency-brand-900",
        "agency-brand",
        "agency-error-50",
        "agency-error-100",
        "agency-error-200",
        "agency-error-300",
        "agency-error-400",
        "agency-error-500",
        "agency-error-600",
        "agency-error-700",
        "agency-error-800",
        "agency-error-900",
        "agency-error-1000",
        "agency-error",
        "agency-success-50",
        "agency-success-100",
        "agency-success-200",
        "agency-success-300",
        "agency-success-400",
        "agency-success-500",
        "agency-success-600",
        "agency-success-700",
        "agency-success-800",
        "agency-success-900",
        "agency-success-1000",
        "agency-success",
        "agency-neutral-0",
        "agency-neutral-50",
        "agency-neutral-100",
        "agency-neutral-200",
        "agency-neutral-300",
        "agency-neutral-400",
        "agency-neutral-500",
        "agency-neutral-600",
        "agency-neutral-700",
        "agency-neutral-800",
        "agency-neutral-900",
        "agency-neutral",
        "primary",
        "subtle",
        "brand",
        "inverse",
        "error",
        "success",
        "warning",
        "highlight",
        "disabled",
        "black",
        "white",
        "surface-primary",
        "surface-primary-hover",
        "surface-primary-selected",
        "surface-secondary",
        "surface-secondary-hover",
        "surface-secondary-selected",
        "surface-brand",
        "surface-brand-hover",
        "surface-brand-selected",
        "surface-brand-light",
        "surface-brand-light-hover",
        "surface-brand-light-selected",
        "surface-brand-lightest",
        "surface-brand-lightest-hover",
        "surface-brand-lightest-selected",
        "surface-neutral",
        "surface-neutral-hover",
        "surface-neutral-selected",
        "surface-error",
        "surface-error-hover",
        "surface-error-selected",
        "surface-success",
        "surface-success-hover",
        "surface-success-selected",
        "surface-warning",
        "surface-warning-hover",
        "surface-warning-selected",
        "surface-highlight",
        "surface-highlight-hover",
        "surface-highlight-selected",
        "surface-error-bold",
        "surface-error-bold-hover",
        "surface-error-bold-selected",
        "surface-success-bold",
        "surface-success-bold-hover",
        "surface-success-bold-selected",
        "surface-brand-accent",
        "surface-disabled",
        "border-secondary",
        "border-secondary-hover",
        "border-secondary-selected",
        "border-subtle",
        "border-subtle-hover",
        "border-subtle-selected",
        "border-brand",
        "border-brand-hover",
        "border-brand-selected",
        "border-error",
        "border-error-hover",
        "border-error-selected",
        "border-success",
        "border-success-hover",
        "border-success-selected",
        "border-warning",
        "border-warning-hover",
        "border-warning-selected",
        "border-highlight",
        "border-highlight-hover",
        "border-highlight-selected",
        "border-brand-light",
        "border-inverse",
        "border-disabled",
        "focus"
      ]
    }
  }
}, qr = Kr;
const _r = Fr(qr), { cva: Hr, cx: Qr, compose: Yr } = ar({
  hooks: {
    onComplete: _r
  }
});
export {
  Qr as a,
  Xr as b,
  Hr as c,
  Zr as d,
  Yr as e
};
//# sourceMappingURL=index-CROKJrb5.js.map
